<template>
  <div class="row">
    <div v-for="signature in signatures" :key="signature.id" class="col-lg-6">
      <Signature :signature="signature" :header="false" />
    </div>
  </div>
</template>

<script>
import Signature from '@/Pages/Asset/Contract/Signatures/Signature';

export default {
  components: {
    Signature,
  },
  props: {
    signatures: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
